import type { MultiProductBannerOfferType } from '@repo/supergraph/marketplace/multiProductBanner/types';
import type { MobileOrDesktop } from '@repo/utils/deviceType/types';
import { EditorialBanner } from './Banners/EditorialBanner';
import { isMultiProductBannerEnabledForSlug } from './utils';

type MultiProductBannerProps = {
  slug?: string;
  multiProductBannerOffers?: MultiProductBannerOfferType[];
  deviceType?: MobileOrDesktop;
};

export const MultiProductBanner = ({
  slug,
  multiProductBannerOffers,
  deviceType,
}: MultiProductBannerProps) => {
  const isMultiProductBannerEnabled = isMultiProductBannerEnabledForSlug(slug || '');

  if (!multiProductBannerOffers || multiProductBannerOffers.length === 0) {
    return null;
  }

  return (
    isMultiProductBannerEnabled && (
      <EditorialBanner offers={multiProductBannerOffers} deviceType={deviceType} />
    )
  );
};
